import {Router, Request, Response, Middleware} from "../utils/Router";
import * as array from "../utils/array";
import {i18n, ll, getLocaleFromUrl} from "../i18n/I18n";
import {parseHash} from "../utils/URL";
import {setupCDPSimple} from "../utils/cdpsimple";
import { upperFirst } from "lodash-es";

import {Dialog} from "../components/flipp-dialog/Dialog";
import {ErrorPage} from "../components/flipp-error-page/ErrorPage";
import {StorePage} from "../components/flipp-store-page/StorePage";
import {NewLandingPage} from "../components/flipp-new-landing-page/NewLandingPage";
import {FavouritesPage} from "../components/flipp-favourites-page/FavouritesPage";
import {NativeLanding} from "../components/flipp-native-landing/NativeLanding";
import {ActionLanding} from "../components/flipp-action-landing/ActionLanding";
import {SearchPage} from "../components/flipp-search-page/SearchPage";
import {CouponsPageEntry} from "../components/flipp-coupons-page/CouponsPageEntry";
import {FlyerPage} from "../components/flipp-flyer-page/FlyerPage";
import {ShoppingListEntry} from "../components/flipp-shopping-list/ShoppingListEntry";
import {ExpiredContentPage} from "../components/flipp-expired-content-page/ExpiredContentPage";

import {Flyer, FlyerCategory} from "../definitions/FlyerDefinitions";
import {DisplayType} from "../definitions/BackflippDefinitions";
import {Coupon} from "../definitions/CouponDefinitions";

import {StorageService} from "../services/StorageService";
import {SeoService, CityJSON} from "../services/SeoService";
import {LocationService, PostalCode, LocationInfo, Country} from "../services/LocationService";
import {FlyerService} from "../services/FlyerService";
import {CouponService} from "../services/CouponService";
import {FavouriteService} from "../services/FavouriteService";
import {BlacklistService} from "../services/BlacklistService";
import {LinkService} from "../services/LinkService";
import {ConfigService, RuntimeConfig, Experience} from "../services/ConfigService";
import {SearchService} from "../services/SearchService";
import {AnalyticsService} from "../services/AnalyticsService";
import {UserAgentService} from "../services/UserAgentService";
import {AuthenticationService} from "../services/AuthenticationService";
import {AuthStatus, LoginState} from "../services/definitions/IAuthenticationService";
import {HistoryService} from "../services/HistoryService";
import {CouponActions, CouponSource, SourceAction} from "../services/definitions/IAnalyticsService";
import BreadcrumbService from "../services/BreadcrumbsService";
import MetadataService from "../services/MetadataService";
import MetaKeywordsService from "../services/MetaKeywordsService";
import MetaTitleAndDescService from "../services/MetaTitleAndDescService";
import {FlyersViewedService} from "../services/FlyersViewedService";
import {ExpiredCanonicalsService} from "../services/ExpiredCanonicalsService";
import {ExpiredMetadaService} from "../services/ExpiredMetadaService";
import {ModalService} from "../services/ModalService";
import {EventService} from "../services/EventService";
import {isCrawler, isChromeHeadless} from "../utils/crawler";
import { Page } from "../components/flipp-page/Page";
import { CategoriesBrowser } from "../components/flipp-categories-browser/CategoriesBrowser";
import { LocationBrowser } from "../components/flipp-location-browser/LocationBrowser";
import { CountryHomepage } from "../components/flipp-country-homepage/CountryHomepage";
import { CityHomepage } from "../components/flipp-city-homepage/CityHomepage";
import CategoryBrowserService from "../services/CategoryBrowserService";
import LocationBrowserService from "../services/LocationBrowserService";
import {SeoDataService} from "../services/SeoDataService";
import {AppRatingService} from "../services/AppRatingService";
import { fetchJSON } from "../utils/fetch";
import {makeCouponPop, makeItemPop} from "../utils/modal";
import {DateTimeService} from "../services/DateTimeService";
import { CCPAForm } from "../components/flipp-data-form/CCPAForm";
import { CCPAFormSuccess} from "../components/flipp-data-form/CCPAFormSuccess";
import {CategoryService} from "../services/CategoryService";
import {BlackFridayService} from "../services/BlackFridayService";

const storageService = StorageService.getInstance();
const locationService = LocationService.getInstance();
const flyerService = FlyerService.getInstance() as FlyerService;
const couponService = CouponService.getInstance() as CouponService;
const favourites = FavouriteService.getInstance() as FavouriteService;
const linkService = LinkService.getInstance();
const config = ConfigService.getInstance();
const searchService = SearchService.getInstance() as SearchService;
const analytics = AnalyticsService.getInstance();
const authService = AuthenticationService.getInstance();
const historyService = HistoryService.getInstance();
const userAgentService = UserAgentService.getInstance();
const blacklistService = BlacklistService.getInstance() as BlacklistService;
const breadcrumbsService = BreadcrumbService.getInstance();
const metadataService = MetadataService.getInstance();
const metaKeywordsService = MetaKeywordsService.getInstance();
const metaTitleAndDescService = MetaTitleAndDescService.getInstance();
const expiredCanonicalsService = ExpiredCanonicalsService.getInstance();
const seoService = SeoService.getInstance();
const seoDataService = SeoDataService.getInstance();
const dateTimeService = DateTimeService.getInstance();
const modalService = ModalService.getInstance();
const appRatingService = AppRatingService.getInstance();
const eventService = EventService.getInstance();


// Define router
export const router = new Router();

// custom transitions for coupon and item
let itemOrCouponDialog: Dialog = null;
function back() {
	historyService.doBack();
}

function couponCloseForward() {
	linkService.execute("/coupons", window);
}

const EXP_ESCAPE_ROUTES = ["/", "/flyers", "/weekly_ads", "/circulaires", "/search",
	"/recherche", "/shopping_list", "/liste_dachats"];

// Public Definitions -------------------------------------------------------->

router
		.addRoute("/:locale/home")
		.addRoute("/:locale/accueil")
		.addRoute("/flyers")
		.addRoute("/flyers/:category")
		.addRoute("/:locale/:city/flyers")
		.addRoute("/:locale/:city/flyers/:category")

		.addRoute("/weekly_ads")
		.addRoute("/weekly_ads/:category")
		.addRoute("/:locale/:city/weekly_ads")
		.addRoute("/:locale/:city/weekly_ads/:category")

		.addRoute("/circulaires")
		.addRoute("/circulaires/:category")
		.addRoute("/:locale/:city/circulaires")
		.addRoute("/:locale/:city/circulaires/:category")

		.addRoute("/:locale/:city/coupons")
		.addRoute("/:locale/:city/coupons/:category")

		.addRoute("/coupon/:slug")
		.addRoute("/:locale/:city/coupon/:slug")

		.addRoute("/search")
		.addRoute("/search/:query")
		.addRoute("/search/:city/:query")
		.addRoute("/search/:city/:query/:sort")
		.addRoute("/:locale/search/:query")
		.addRoute("/:locale/search/:city/:query")
		.addRoute("/:locale/search/:city/:query/:sort")

		.addRoute("/recherche")
		.addRoute("/recherche/:query")
		.addRoute("/recherche/:city/:query")
		.addRoute("/recherche/:city/:query/:sort")
		.addRoute("/:locale/recherche/:query")
		.addRoute("/:locale/recherche/:city/:query")
		.addRoute("/:locale/recherche/:city/:query/:sort")

		.addRoute("/:city/flyer/:slug")
		.addRoute("/:city/weekly_ad/:slug")
		.addRoute("/:city/circulaire/:slug")
		.addRoute("/:locale/:city/flyer/:slug")
		.addRoute("/:locale/:city/weekly_ad/:slug")
		.addRoute("/:locale/:city/circulaire/:slug")

		.addRoute("/item/:slug")
		.addRoute("/:locale/:city/item/:slug")
		.addRoute("/produit/:slug")
		.addRoute("/:locale/:city/produit/:slug")

		.addRoute("/en-us/:city")
		.addRoute("/en-ca/:city")
		.addRoute("/fr-ca/:city")

		.addRoute("/:locale/store/:storename")

		.addRoute("/:locale/categories")
		.addRoute("/:locale/categories/:category")
		.addRoute("/:locale/categories/:category/:sub_category")

		.addRoute("/:locale/products/:product_name/browser")
		.addRoute("/:locale/products/:product_name/browser")
		.addRoute("/:locale/products/:product_name/browser/:state")

		.addRoute("/:locale/browser")
		.addRoute("/:locale/browser")
		.addRoute("/:locale/browser/:state")

		.addRoute("/:locale/browser/:state/categories")
		.addRoute("/:locale/browser/:state/categories/:category")
		.addRoute("/:locale/browser/:state/categories/:category/:sub_category")

		.addRoute("/blackfriday")
		.addRoute("/blackfriday/:locale")

		.use((req, res, next) => {
			/* This is awkward, but we don't know the runtime behaviour until the first request. Requests from
				* native distribution will come in on the /dist route, otherwise we can assume it's the default
				* behaviour. The assumption here is that native distribution will ALWAYS drive to the /dist path
				* FIRST. */

			if (!analytics.isInitialized() && req.path === "/login_redirect") {
				/* Don't configure analytics if the first request is a login redirect. This can only be the case
					* for the fallback OAuth flow for IE11 where we are using full page transitions instead of
					* postMessage between windows. */
				return next();
			} else if (analytics.isInitialized()) {
				/* If the runtime is Distribution, we need to check for the user transitioning out of
					* the flyer view (eg: clicking the Flipp logo to go to the flyer listing). Once this
					* occurs, we break out of the 'distribution experience' (with embedded SL, x-browse
					* section, etc) and render the site as normal (with left nav, etc)
					* TODO: explore whether this is possible to add custom transitions in the router
					*/
				if (config.RUNTIME === RuntimeConfig.DISTRIBUTION &&
					EXP_ESCAPE_ROUTES.indexOf(req.path) !== -1) {
					config.EXPERIENCE = Experience.DEFAULT;
					document.documentElement.removeAttribute("experience");
				}
				return next();
			}

			const isNativeReq = req.path === "/dist";
			/*
				Save the properties required for the circular destination service
			*/
			// True if route is not /dist but we want to show the distribution experience
			const forceNativeExperience = setupCDPSimple(isNativeReq, req);
			config.RUNTIME = isNativeReq || forceNativeExperience ? RuntimeConfig.DISTRIBUTION : RuntimeConfig.DEFAULT;
			config.EXPERIENCE = isNativeReq || forceNativeExperience ? Experience.DISTRIBUTION : Experience.DEFAULT;

			analytics.init(config.RUNTIME);

			if (isNativeReq && req.params["blacklist_merchant_ids"]) {
				const blacklistedIds = req.params["blacklist_merchant_ids"]
					.split(",")
					.map(Number);
				blacklistService.addBlacklistedMerchants(blacklistedIds);
			}

			/* Check if the params contain a 'context' param. If so, just redirect to the provided
				* URL after the runtime have been configured */
			if (isNativeReq && req.params["context"]) {

				document.documentElement.setAttribute("postalcode", req.params["fsa"]);
				document.documentElement.setAttribute("city", ""); /* Is 'city' used anywhere in the native exp? */

				if (req.params["exp"] === "native") {
					document.documentElement.setAttribute("experience", "native");
				}
				res.redirect(req.params["context"]);
				return;
			} else if (isNativeReq) {
				const searchFsa = req.params["fsa"];
				if (searchFsa && PostalCode.isValid(searchFsa)) {
					document.documentElement.setAttribute("postalcode", searchFsa);
					document.documentElement.setAttribute("city", ""); /* Is 'city' used anywhere in the native exp? */
				}
			}
			return next();
		})
		.use((req, res, next) => {
			if (config.RUNTIME === RuntimeConfig.DISTRIBUTION) {
				/* Don't use push state for Safari in distribution mode. See HistoryService for details */
				config.PUSHSTATE_SUPPORTED = !bowser.safari;
			}
			return next();
		})
		.use((req, res, next) => {
			if (document.documentElement.hasAttribute("postalcode") &&
					document.documentElement.hasAttribute("city")) {
				return next();
			}

			const infoPromise: Promise<LocationInfo> = ("postal_code" in req.params)
				? locationService.savePostalCode(new PostalCode(req.params["postal_code"]))
				: locationService.getLocationInfo();

			return infoPromise.then((info) => {
				// TODO this won't work for isomorphic...
				document.documentElement.setAttribute("postalcode", info.postal_code);
				document.documentElement.setAttribute("city", info.city_name);
				req.locationInfo = {...info};
			}).then(next);
		})
		.use(async (req, res, next) => {
			// If it's
			// Check if we need to re-center the postal_code for SEO purposes.
			// If we have a :city parameter - and the current postal code is NOT
			// inside the list of that cities postal codes, then re-center the user
			// to match the city fallback UNLESS there is an explicit postal_code
			// already set - so we shouldn't obey the :city parameter.
			//
			// This is to allow us to give googlebot URLs that work in a city and they
			// can crawl correctly, but users don't get their postal_code preferences
			// trampled.

			// @todo remove hack for support legacy inCity parameter
			if (!("city" in req.params || "in-city" in req.params)) {
				return next();
			}

			const inCity = req.params["city"] || req.params["in-city"];
			if (inCity.length === 0 || inCity.indexOf("-") === -1) {
				return next();
			}

			const splittedInCity = inCity.split("-");
			const state = splittedInCity.pop();
			const city = splittedInCity.join("_");

			try {
				seoService.inCity = inCity;
				if ("postal_code" in req.params) {
					return next();
				}
				if (req.locationInfo && req.locationInfo.city_name === city.replace("_", " ")) {
					await locationService.savePostalCode(new PostalCode(req.locationInfo.postal_code));
					return next();
				}

				const cityJSON: CityJSON = await seoService.getCityInfo(state, city);

				if (!cityJSON.geo_codes || cityJSON.geo_codes.length === 0) {
					return;
				}

				// If we are NOT in the current city, the we need to re-center.
				if (cityJSON.geo_codes.indexOf(locationService.geoCode) === -1) {
					const info: LocationInfo = await locationService
						.savePostalCode(new PostalCode(cityJSON.fallback_postal_code));
					req.locationInfo = info;

					// TODO this won't work for isomorphic...
					document.documentElement.setAttribute("postalcode", info.postal_code);
					document.documentElement.setAttribute("city", info.city_name);
				}
			} catch (e) {}

			return next();

		})

		// locale and location are not necessarily related!
		.use(async (req, res, next) => {
			if (seoService.hasLocale()) {
				return next();
			}

			const getLocale = async () => {
				if (getLocaleFromUrl()) {
					return getLocaleFromUrl();
				} else if ("locale" in req.params) {
					return req.params["locale"];
				} else if (storageService.getItem("locale")) {
					const locale = storageService.getItem("locale");

					/* Check to ensure the saved locale is consistent with the postalcode. If it's not,
						* don't use the saved version and instead fall back */
					const code = document.documentElement.getAttribute("postalcode");
					const postalCode = new PostalCode(code);
					if (postalCode.country === Country.CANADA && (locale === "en-ca" || locale === "fr-ca")) {
						return locale;
					} else if (postalCode.country === Country.USA && locale === "en-us") {
						return locale;
					}
				}
				// FIXME [FW-77] Backflipp should be *the* definitive source for
				// locale, by using `Accept-Language`
				const info: LocationInfo = await locationService.getLocationInfo();
				if (info.country_code.toLowerCase() !== "ca") {
					return "en-us";
				}

				return info.region_name === "QC" ? "fr-ca" : "en-ca";
			};

			let locale = await getLocale();
			locale = seoService.fixTrailingSlash(locale);
			seoService.setLocale(locale);

			return next();
		})

		.use((req, res, next) => {
			// has postal code & locale
			const postalCode = document.documentElement.getAttribute("postalcode");
			const locale = seoService.locale;

			analytics.setPostalCode(postalCode);
			analytics.setLocale(locale);

			return next();
		})

		.use((req, res, next) => {
			metadataService.removeCanonicalLink(req.params);

			if (config.isProduction() && (isChromeHeadless() || (!isChromeHeadless() && !config.isCDN()))) {
				metadataService.removeRobotsNoIndexTag();
			}

			return next();
		})
		.use((req, res, next) => {
			// Init the auth service
			return authService.init()
				.then(() => {
					/* After initialization, set account guid on analytics if user is logged in. It's slightly
					 * hackish to do it here, but AnalyticsService cannot have a dependency on AuthenticationService
					 * directly */
					if (authService.status === AuthStatus.LOGGED_IN) {
						analytics.setAccountGuid(authService.user.token.user_id);
					}
					return next();
				});
		})

		.use((req, res, next) => {
			// Theme color update
			config.updateThemeColor(req);

			return next();
		})
		.use((req, res, next) => {
			// Update merchant xbrowse configs
			config.updateXBrowse(req);
			return next();
		})
		.use( (req, res, next) => {
			if (isCrawler()) {
				const errorElement = document.getElementById("error-page");
				if (errorElement) {
					errorElement.parentNode.removeChild(errorElement);
				}
			}
			return next();
		})
		.use(async (req, res, next) => {
			const promises = [
				seoDataService.fetchCanadianProvinces(),
				seoDataService.fetchUsStates(),
				seoDataService.fetchCaCities(),
				seoDataService.fetchUsCities(),
				seoDataService.fetchCaMerchants(),
				seoDataService.fetchUsMerchants(),
			];
			metadataService.setReqParamsQuery(req.params);

			if (userAgentService.mobile) {
				promises.push(appRatingService.fetchAppRating());
			}
			await Promise.all(promises);

			await metadataService.canonicalizeLocale();

			return next();
		})
		.use((req, res, next) => {
			seoService.removeScripts();
			seoService.setCrawlerCss();
			return next();
		})
		.use(async (req, res, next) => {
			const sessionID = storageService.getItem("session_id");
			if (sessionID) {
				Cookies.set("session_id", sessionID, { expires: 365 });
			}
			storageService.removeItem("session_id");

			const shoppingList = JSON.parse(storageService.getItem("shopping_list") || "{}");
			if (shoppingList.users) {
				Cookies.set("users", JSON.stringify(shoppingList.users), { expires: 365 });
			}

			delete shoppingList.users;
			storageService.setItem("shopping_list", JSON.stringify(shoppingList));

			return next();
		})
		// Declare the route paths
		// NOTE: this gives us flexibility on how we could set up the inverse:
		// given a target route name and locale generate the path...
		.route("/", "index")
		.route("/home", "home")
		.route("/search/:query", "search")
		.route("/recherche/:query", "search")

		.route("/:locale/home", "home")
		.route("/accueil", "home")
		.route("/:locale/accueil", "home")

		.route("/en-us", "country_homepage")
		.route("/en-ca", "country_homepage")
		.route("/fr-ca", "country_homepage")

		.route("/flyers", "listing")
		.route("/flyers/:category", "listing")
		.route("/:locale/:city/flyers", "listing")
		.route("/:locale/:city/flyers/:category", "listing")

		.route("/weekly_ads", "listing")
		.route("/weekly_ads/:category", "listing")
		.route("/:locale/:city/weekly_ads", "listing")
		.route("/:locale/:city/weekly_ads/:category", "listing")

		.route("/circulaires", "listing")
		.route("/circulaires/:category", "listing")
		.route("/:locale/:city/circulaires", "listing")
		.route("/:locale/:city/circulaires/:category", "listing")

		.route("/:locale/store/:storename", "store")

		.route("/dist", "distribution")

		.route("/:locale/browser", "states_browser")
		.route("/:locale/browser/:state", "cities_browser")

		.route("/:locale/browser/:state/:city", "categories")
		.route("/:locale/browser/:state/:city/:category", "sub_categories")
		.route("/:locale/browser/:state/:city/:category/:sub_category", "categories_products")

		.route("/:locale/categories", "categories")
		.route("/:locale/categories/:category", "sub_categories")
		.route("/:locale/categories/:category/:sub_category", "categories_products")

		.route("/en-us/:city", "city_homepage")
		.route("/en-ca/:city", "city_homepage")
		.route("/fr-ca/:city", "city_homepage")

		.route("/:locale/products/:product_name/browser", "states_browser")
		.route("/:locale/products/:product_name/browser/:state", "cities_browser")

		.route("/blackfriday", "blackfriday")
		.route("/blackfriday/:locale", "blackfriday")


		// Capture the old routes and redirect
		.route("/flyer", (req, res) => {
			const flyerId = parseInt(req.params["id"], 10);
			return flyerService.getFlyer(flyerId).then((flyer) => {
				if (!flyer) {
					res.redirect(linkService.linkTo("listing"));
				} else {
					res.redirect(linkService.linkTo(flyer), 301);
				}
			});
		})

		.route("/item", (req, res) => {
			const itemId = parseInt(req.params["id"], 10);
			return flyerService.getFlyerItem(itemId).then((item) => {
				if (!item) {
					res.redirect(linkService.linkTo("listing"));
				} else {
					res.redirect(linkService.linkTo(item), 301);
				}
			});
		})

		.route("/flyer_type", (req, res) => {
			const flyerTypeId = parseInt(req.params["id"], 10);
			return flyerService.getFlyers().then((flyers) => {
				const firstFlyer = array.find(flyers, (flyer) =>
						flyer.flyerTypeId === flyerTypeId);

				if (firstFlyer) {
					res.redirect(linkService.linkTo(firstFlyer));
				} else {
					res.redirect(linkService.linkTo("listing"));
				}
			});
		})

		.route("/category", (req, res) => {
			const category = req.params["id"];
			return flyerService.getFlyers().then((flyers) => {
				const firstFlyer = array.find(flyers, (flyer) =>
						flyer.categories.indexOf(category) !== -1);

				if (firstFlyer) {
					res.redirect(linkService.linkTo(firstFlyer));
				} else {
					res.redirect(linkService.linkTo("listing"));
				}
			});
		})

		// Dispatch route
		.route("/share", dispatchFlyerOpen)
		.route("/action", (req, res, next) => {
			if (req.params["type"] === "flyer_view") {
				return dispatchFlyerOpen(req, res, next);
			} else if (req.params["type"] === "shopping_list") {
				return dispatchShoppingListShare(req, res, next);
			} else if (req.params["type"] === "coupons" || req.params["type"] === "loyalty_cards") {
				return dispatchCouponsListing(req, res, next);
			} else if (req.params["type"] === "browse") {
				return dispatchFlyerListing(req, res, next);
			} else if (req.params["type"] === "search") {
				return dispatchFlyerListing(req, res, next);
			} else if (req.params["type"] === "brand_media" && req.params["command"] === "landing") {
				return dispatchBrandmediaLanding(req, res, next);
			}
			return next();
		})

		// A link used for redirection, for when postal code changes to get the
		// right localized url
		.route("/redirect", (req, res, next) => {

			/* If 'old_fsa' is included as a param to this route, it means that the
			 * user has just changed their FSA. We want to send a beacon for this. */
			const oldFsa = req.params["old_fsa"];
			if (oldFsa) {
				analytics.trackLocationChanges(oldFsa, locationService.postalCode);
			}

			let page = req.params["page"];
			if (BlackFridayService.getInstance().isOnHost()) {
				page = "index";
			}
			if (!page) return next();
			const url = linkService.linkTo(page);
			if (!url) return next();
			res.redirect(url);
		})

		// Login redirect route for the fallback oauth case
		.route("/login_redirect", (req, res, next) => {
			const params = parseHash(req.url);
			if (bowser.msie && Number(bowser.version) <= 11) {
				/* IE 11 is a steaming pile and does not support postMessage across
					* tabs/windows opened using window.open. We need to use a fallback mechanism
					* using full page redirects */
				let redirect: string;
				try {
					const state = JSON.parse(params["state"]) as LoginState;
					redirect = state.path;
				} catch (e) {}
				res.redirect(redirect);
			} else {
				/* Pass the login info back to parent window to complete the login */
				window.opener.postMessage({
					result: "success",
					data: params
				}, req.url.origin);
				window.close();
			}
		})

		.route("/flyer/:slug", "browse")
		.route("/weekly_ad/:slug", "browse")
		.route("/circulaire/:slug", "browse")

		.route("/:city/flyer/:slug", "browse")
		.route("/:city/weekly_ad/:slug", "browse")
		.route("/:city/circulaire/:slug", "browse")
		.route("/:locale/:city/flyer/:slug", "browse")
		.route("/:locale/:city/weekly_ad/:slug", "browse")
		.route("/:locale/:city/circulaire/:slug", "browse")

		.route("/item/:slug", "item")
		.route("/:locale/:city/item/:slug", "item")
		.route("/produit/:slug", "item")
		.route("/:locale/:city/produit/:slug", "item")

		.route("/coupons", "coupons")
		.route("/coupons/:category", "coupons")
		.route("/:locale/:city/coupons", "coupons")
		.route("/:locale/:city/coupons/:category", "coupons")

		.route("/coupon/:slug", "coupon")
		.route("/:locale/:city/coupon/:slug", "coupon")


		.route("/clippings", "clippings")
		.route("/coupures", "clippings")

		.route("/search", "search")
		.route("/search/:city/:query", "search")
		.route("/search/:city/:query/:sort", "search")
		.route("/:locale/search/:query", "search")
		.route("/:locale/search/:city/:query", "search")
		.route("/:locale/search/:city/:query/:sort", "search")

		.route("/recherche", "search")
		.route("/recherche/:city/:query", "search")
		.route("/recherche/:city/:query/:sort", "search")
		.route("/:locale/recherche/:query", "search")
		.route("/:locale/recherche/:city/:query", "search")
		.route("/:locale/recherche/:city/:query/:sort", "search")

		.route("/install", "install")
		.route("/telechargez", "install")

		.route("/shopping_list", "shoppinglist")
		.route("/liste_dachats", "shoppinglist")

		.route("/data", "ccpa_form")
		.route("/data/success", "ccpa_form_success")

		.route("/favourites", "favourites")
		.route("/favorites", "favourites")
		.route("/favoris", "favourites")

		.route("/playstore", "playstore")
		.route("/appstore", "appstore")
		// Default 404 handler
		.use((req, res) => {
			const isWatchList = req.params["type"] === "watchlist";
			if (isWatchList) {
				metaTitleAndDescService.setWatchlist(res);
			} else {
				res.status = 404;
				metaTitleAndDescService.setNotFound(res);
			}
			res.render(<ErrorPage page={true} isWatchList={isWatchList.toString()}  />).then(() => {
				analytics.trackPageNotFoundEvent();
			});
		});

		// .route(500, (req, res) => {

		// })

const routingToCoupon = (req: Request, res: Response) => {
	const couponId = parseInt(req.params["slug"].split("-")[0], 10);
	return couponService.getCoupon(couponId).then((coupon) => {
		setCouponTitleAndDescription(coupon, res);

		analytics.trackCoupon(coupon, CouponActions.Open, CouponSource.CouponListing);
		itemOrCouponDialog = makeCouponPop(coupon);
		itemOrCouponDialog.showModal();

		itemOrCouponDialog.addEventListener("close", back);
		itemOrCouponDialog.addEventListener("flipp-navigate", (e) => {
			itemOrCouponDialog.removeEventListener("close", back);
			itemOrCouponDialog.close();
		});
	});
};

const routingFromCoupon = (req: Request, res: Response) => {
	// close the dialog
	itemOrCouponDialog.removeEventListener("close", back);
	itemOrCouponDialog.removeEventListener("close", couponCloseForward);
	itemOrCouponDialog.addEventListener("flipp-navigate", (e) => {
		itemOrCouponDialog.removeEventListener("close", couponCloseForward);
		itemOrCouponDialog.removeEventListener("close", back);
		itemOrCouponDialog.close();
	});
	if (itemOrCouponDialog.open) itemOrCouponDialog.close();

	metaTitleAndDescService.setCoupon(req, res);
};

		// Coupon pop routes
router.route({
			from: "coupons",
			to: "coupon"
		}, routingToCoupon)
		.route({
			from: "coupon",
			to: "coupons"
		}, routingFromCoupon)
		.route({
			from: "city_homepage",
			to: "coupon"
		}, routingToCoupon)
		.route({
			from: "coupon",
			to: "city_homepage"
		}, routingFromCoupon)

		// Item pop routes
		.route({
			from: "browse",
			to: "item"
		}, (req, res, next) => {
			const itemId = parseInt(req.params["slug"].split("-")[0], 10);
			return flyerService.getFlyerItem(itemId).then((item) => {

				if (!item) {
					return next();
				}
				return Promise.all([
					couponService.getCouponsForFlyerItem(itemId),
					flyerService.getFlyer(item.flyerId)
				]).then(([coupons, flyer]) => {
					res.status = 200;
					metaTitleAndDescService.setItem(res, item, flyer);

					if (item.displayType === DisplayType.COUPONV2 || item.displayType === DisplayType.COUPONV3) {
						/* If display type is COUPONV2 or COUPONV3, then we know this is the P&G BrandSaver so we
						 * actually want to display the Coupon pop instead of Item pop.
						 * Edge case: if no coupon matchup exists for this item, it means that that coupon is not
						 * available (clip limit, not in FSA) and we should show the Item pop with "not available"
						 * overlay */
						if (coupons.length > 0) {
							itemOrCouponDialog = makeCouponPop(coupons[0]);
						} else {
							itemOrCouponDialog = makeItemPop(item, flyer, coupons);
						}
					} else {
						itemOrCouponDialog = makeItemPop(item, flyer, coupons);
					}

					itemOrCouponDialog.addEventListener("close", back);
					itemOrCouponDialog.addEventListener("flipp-navigate", (e) => {
						itemOrCouponDialog.removeEventListener("close", back);
						itemOrCouponDialog.close();
					});
					itemOrCouponDialog.showModal();

					if (item.displayType === DisplayType.VIDEO) {
						analytics.trackFlyerItem(flyer, item.id, 11);
					} else {
						analytics.trackFlyerItem(flyer, item.id, 0);
					}
				});
			});
		})

		.route({
			from: "item",
			to: "browse"
		}, (req, res, next) => {
			itemOrCouponDialog.removeEventListener("close", back);
			if (itemOrCouponDialog.open) itemOrCouponDialog.close();

			const flyerId = parseInt(req.params["slug"].split("-")[0], 10);

			return flyerService.getFlyer(flyerId, true, true)
					.then(async (flyer) => {
						await metaTitleAndDescService.setListing(res, flyer);
				});
		})

		.route({
			from: "search",
			to: "browse"
		}, async (req, res, next) => {
			const itemId = parseInt(req.params["slug"].split("-")[0], 10);
			const [item, coupons, flyer] = await modalService.getItemModalData(itemId, req, res, next);
			itemOrCouponDialog = modalService.makePop(item, coupons, flyer);
			itemOrCouponDialog.showModal();
		})

		.route({
			from: "item",
			to: "search"
		}, (req, res) => {
			linkService.execute(`/search/${req.params.query}`, window);
			eventService.closePopupInSearch();
			window.removeEventListener("flipp-dialog-close", back);
		})

		// Define the handlers
		.define("index", async (req, res, next) => {
				metaTitleAndDescService.setHomePage(res);
				const landingPageEntry = storageService.getItem("landing_page");
				let showLandingPage = true;
				try {
					const entry = JSON.parse(landingPageEntry);
					const expired = !entry ? true : new Date().getTime() > Number(entry.expires_at);
					if (!entry || expired) {
						showLandingPage = true;
					}
				} catch (e) {
					showLandingPage = true;
				}

				if (showLandingPage) {
					const time = dateTimeService.getNow();
					storageService.setItem("landing_page", JSON.stringify({
						expires_at: time.plus({months: 1}).valueOf()
					}));

					const bfService = BlackFridayService.getInstance();
					if (bfService.isOnHost() && bfService.isEnabled()) {
						const { render } = await import("./routes/blackfriday");
						return render(req, res);
					}

					res.redirect(linkService.linkTo("home"));
				} else {
					res.redirect(linkService.linkTo("listing"));
				}
		})

		.define("home", (req, res) => {
			renderHomePage(req, res);
		})

		.define("store", async (req, res) => {
			const store = req.params["storename"]
				.replace(/usa|canada/gi, "")
				.split("-")
				.map(e => upperFirst(e))
				.join(" ");

			metaTitleAndDescService.setMerchant(res, store);
			metadataService.setAmpLink(req.path);
			metaKeywordsService.setStorePageKeywords(store);
			res.render(<StorePage store={req.params["storename"]} />);
		})

		.define("listing", async (req, res, next: any) => {
			const { default: route } = await import("./routes/listing");
			route(req, res, next);
		})

		.define("browse", async (req, res, next) => {
			metadataService.setFlyerPageLink(req.params["slug"]);
			// Return a promise since we need to get some data before responding
			const flyerId = parseInt(req.params["slug"].split("-")[0], 10);
			const itemId = "item_id" in req.params ?
					parseInt(req.params["item_id"], 10) : null;
			const flyer = await flyerService.getFlyer(flyerId, true, true);
			if (!flyer && !isCrawler()) {
				const link = expiredCanonicalsService.getFlyersLink();
				return metadataService.redirectAsync(link, "redirect_flyer_message");
			}

			if (flyer) {
				metadataService.setUnavailableAfterTag(flyer.validTo);
			}

			await ExpiredMetadaService.getInstance().setFlyerData(flyerId);

			res.status = 200;
			metaTitleAndDescService.setFlyer(res, flyer);

			const flyerName = (flyer as any).flyer_name ? (flyer as any).flyer_name : flyer.getName();
			metaKeywordsService.setFlyerPageKeywords(flyerName);
			// If req.sourceAction is not defined, that means that we DIRECTLY entered
			// the flyer URL into the browser as opposed to using <Link>.
			// Mark appropriately.
			// ----------------------------------------------------------------------
			const source = (req.details && req.details.sourceAction) ? req.details.sourceAction : SourceAction.Direct;
			const flyerDetails = (req.details && req.details.context) ? req.details.context : null;
			const merchant = flyer && flyer.merchant ? flyer.merchant : "";

			res.render(<FlyerPage merchant={merchant} flyerId={flyerId} sourceAction={source} itemId={itemId} flyerDetails={flyerDetails} />).then(() => {
				if (flyerDetails) {
					// Fast flyer case - track flyer open immediately
					analytics.trackFlyerOpen(flyerDetails.flyer, source);
					return;
				}
				flyerService.getFlyer(flyerId).then((flyer) => {
					if (!flyer) {
						analytics.trackPageNotFoundEvent();
						return;
					}
					FlyersViewedService.getInstance().count();
					analytics.trackFlyerOpen(flyer, source);
				});
			});
		})

		.define("item", async (req, res, next) => {
			metadataService.setItemPageLink(req.params["slug"]);
			// Return a promise since we need to get some data before responding
			const itemId = parseInt(req.params["slug"].split("-")[0], 10);
			const item = await flyerService.getFlyerItem(itemId);
			if (!item) {
				const link = expiredCanonicalsService.getItemLink();
				metadataService.setCanonicalAsync(link);
				await ExpiredMetadaService.getInstance().setItemData(req.params["slug"], itemId);
				if (isCrawler()) {
					const body = ExpiredMetadaService.getInstance().getItemBody();
					const h1 = ExpiredMetadaService.getInstance().getItemH1();
					metaTitleAndDescService.setExpiredItem(res);
					res.render(<ExpiredContentPage body={body} h1={h1} />);
					return;
				}

				metadataService.redirectAsync(link, "redirect_item_message");
				return next();
			}

			const flyer = await flyerService.getFlyer(item.flyerId);
			metadataService.setUnavailableAfterTag(item.validTo);
			metaKeywordsService.setItemPageKeywords(item.name, flyer.name);
			breadcrumbsService.setData(item);
			return Promise.all([
				couponService.getCouponsForFlyerItem(itemId),
				flyerService.getFlyer(item.flyerId)
			]).then(([coupons, flyer]) => {
				if (!flyer) return next();

				res.status = 200;
				metaTitleAndDescService.setItemPage(res, item);

				function forward() {
					// forward navigate
					linkService.execute(linkService.linkTo(flyer), window);
				}

				function displayItem() {
					if (item.displayType === DisplayType.COUPONV2 || item.displayType === DisplayType.COUPONV3) {
						/* If display type is COUPONV2 or COUPONV3, then we know this is the P&G BrandSaver so we
						* actually want to display the Coupon pop instead of Item pop.
						* Edge case: if no coupon matchup exists for this item, it means that that coupon is not
						* available (clip limit, not in FSA) and we should show the Item pop with "not available"
						* overlay */
						if (coupons.length > 0) {
							itemOrCouponDialog = makeCouponPop(coupons[0]);
						} else {
							itemOrCouponDialog = makeItemPop(item, flyer, coupons);
						}
					} else {
						itemOrCouponDialog = makeItemPop(item, flyer, coupons);
					}

					seoService.insertLoadingMarker(70);
					itemOrCouponDialog.addEventListener("close", forward);
					itemOrCouponDialog.addEventListener("flipp-navigate", (e) => {
						itemOrCouponDialog.removeEventListener("close", forward);
						itemOrCouponDialog.close();
					});
					itemOrCouponDialog.showModal();

					if (item.displayType === DisplayType.VIDEO) {
						analytics.trackFlyerItem(flyer, item.id, 11);
					} else {
						analytics.trackFlyerItem(flyer, item.id, 0);
					}
				}

				if (isCrawler()) {
					res.render(<Page show="coupons" merchant={item.merchant}/>).then(() => {
						displayItem();
					});
				} else {
					res.render(<FlyerPage flyerId={item.flyerId} sourceAction={SourceAction.Direct}/>)
						.then(() => {
							analytics.trackFlyerOpen(flyer, SourceAction.Direct);
							displayItem();
						});
				}
			});
		})

		.define("coupons", async (req, res, next) => {
			await metadataService.setCouponsPageLink();
			const userAgent = UserAgentService.getInstance();
			if (userAgent.mobile) {
				res.redirect(linkService.linkTo("install", {
					feature: "coupons"
				}));
				return;
			}

			const category = req.params["category"] || "all-deals";
			const categoryService = CategoryService.getInstance();
			const couponSlugToName = categoryService.getCouponsToSlugMapping();

			if (!(category in couponSlugToName)) {
				return next();
			}

			const categoryName = couponSlugToName[category];
			metaKeywordsService.setCouponsKeywords();
			metaTitleAndDescService.setCoupons(req, res);

			Promise.all([
				res.render(<CouponsPageEntry category={categoryName} />),
				couponService.getCoupons()
			]).then(([, coupons]) => {
				const filteredCoupons = coupons.filter(coupon =>
					array.contains(coupon.categories, categoryName));

				const sortOrder: string = "all";
				analytics.trackCouponListing(categoryName, filteredCoupons, sortOrder);
			});
		})

		.define("coupon", async (req, res, next) => {
			metadataService.setCouponPageLink(req.params["slug"]);
			const couponId = parseInt(req.params["slug"].split("-")[0], 10);
			const coupon = await couponService.getCoupon(couponId);
			if (!coupon) {
				const link = expiredCanonicalsService.getCouponsLink();
				metadataService.setCanonicalAsync(link);
				await ExpiredMetadaService.getInstance().setCouponData(req.params["slug"], couponId);
				if (isCrawler()) {
					const body = ExpiredMetadaService.getInstance().getCouponBody();
					const h1 = ExpiredMetadaService.getInstance().getCouponH1();
					metaTitleAndDescService.setCouponPage(res);
					res.render(<ExpiredContentPage body={body} h1={h1} />);
					return;
				}

				return metadataService.redirectAsync(link, "redirect_coupon_message");
			}

			metaKeywordsService.setCouponsPageKeywords(coupon.promotionText);
			metadataService.setUnavailableAfterTag(coupon.validTo);
			breadcrumbsService.setData({...coupon, name: coupon.promotionText});
			setCouponTitleAndDescription(coupon, res);

			res.render(<CouponsPageEntry category={req.params["category"]} />).then(() => {

				itemOrCouponDialog = makeCouponPop(coupon);
				itemOrCouponDialog.showModal();
				analytics.trackCoupon(coupon, CouponActions.Open, CouponSource.CouponListing);

				itemOrCouponDialog.addEventListener("close", () => {
					if (req.params.locale && req.params.city) {
						linkService.execute(`/${req.params.locale}/${req.params.city}/coupons`, window);
					} else {
						itemOrCouponDialog.addEventListener("close", couponCloseForward);
					}
				});
				itemOrCouponDialog.addEventListener("flipp-navigate", (e) => {
					itemOrCouponDialog.removeEventListener("close", back);
					itemOrCouponDialog.removeEventListener("close", couponCloseForward);
					itemOrCouponDialog.close();
				});

			});
		})

		.define("clippings", (req, res) => {
			res.redirect(linkService.linkTo("shopping_list"));
		})

		.define("shoppinglist", (req, res) => {
			metaTitleAndDescService.setShoppingList(res);
			res.render(<ShoppingListEntry />);
		})

		.define("favourites", (req, res) => {
			metaTitleAndDescService.setFavourites(res);
			Promise.all([
				res.render(<FavouritesPage />),
				flyerService.getFlyers()
			]).then(([, flyers]) => {
				const favMerchants = favourites.getFavouriteMerchantIds();
				const categoryName: string = "favorites";
				const sortOrder: string = "favorites";
				analytics.trackFlyerListing(categoryName, flyers, sortOrder, favMerchants);
			});
		})

		.define("install", async (req, res) => {
			const { default: route } = await import("./routes/install");
			route(req, res);
		})

		.define("search", (req, res) => {
			const q = req.params["query"] || req.params["q"];
			const sort = req.params["sort"] || "all";

			metaTitleAndDescService.setSearch(req, res);

			Promise.all([
				res.render(<SearchPage query={q} sort={sort} />),
				searchService.getSearchResult(q)
			]).then(([, [flyers, items, coupons, ecomItems]]) => {
				const numFlyers = flyers.filter((flyer) => !flyer.isTombstone).length;
				const tombstoneCount = flyers.length - numFlyers;
				const couponMatchupsCounts = coupons.map((coupon) => coupon.matchUps.length);
				const couponMatchupCount = couponMatchupsCounts.length === 0 ?
					0 : couponMatchupsCounts.reduce((prev, current) => prev + current);
				const numEcomItems = Array.isArray(ecomItems) ? ecomItems.length : 0;

				analytics.trackSearch(q, numFlyers, tombstoneCount, items.length, numEcomItems, coupons.length, couponMatchupCount, "global");
			});
		})

		.define("distribution", (req, res) => {
			const flyerId = req.params["flyer_id"] ? parseInt(req.params["flyer_id"], 10) : null;
			const flyerRunId = req.params["flyer_run_id"] ? parseInt(req.params["flyer_run_id"], 10) : null;
			const merchantId = req.params["merchant_id"] ? parseInt(req.params["merchant_id"], 10) : null;
			res.render(<NativeLanding flyerId={flyerId} flyerRunId={flyerRunId} merchantId={merchantId} />);
		})

		.define("appstore", (req, res) => {
			window.location.href = userAgentService.iosAppLink();
		})

		.define("playstore", (req, res) => {
			window.location.href = userAgentService.getAndroidAppLink("playstore_redirect");
		})
		.define("country_homepage", async (req, res) => {
			if (!isCrawler()) {
				renderHomePage(req, res);
				return;
			}
			const locale = window.location.pathname.replace("/", "");
			const json: { [key: string]: any } = await fetchJSON(config.TOP_COUNTRIES_CITIES);
			const topCities = json[locale].map((city: any) => ({
				name: city.name.split(" ").join("_"),
				state: city.state
			}));

			const toLinks = (e: any, stateName: string, cityName: string) => {
				const cityParsed = cityName.split("_").map(c => c.toLowerCase()).join("-");
				const href =  e instanceof Flyer ? linkService.getFlyerLink(e) : linkService.getCouponLink(e, "");

				return {
					href: `${locale}/${cityParsed}-${stateName}${href}`.toLowerCase(),
					name: e instanceof Flyer ? e.getName() : (e.saleStory || e.promotionText)
				};
			};

			const cityPromises = topCities.map(async (city: any) => {
				const {state, name} = city;

				const fullCityInfo = await seoService.getCityInfo(state, name);
				const flyers = await flyerService.getFlyers(fullCityInfo.fallback_postal_code);
				const coupons = await couponService.getSortedCoupons(null, fullCityInfo.fallback_postal_code);

				return {
					topFlyers: flyers.slice(0, 5).map(e => toLinks(e, state, name)),
					topCoupons: coupons.slice(0, 5).map(e => toLinks(e, state, name)),
					name,
					state
				};
			});

			const citiesLinks = [];
			for (const cityPromise of cityPromises) {
				const city = await cityPromise;
				citiesLinks.push(city);
			}

			metadataService.setAmpLink(req.path);
			metaTitleAndDescService.setCountryHomePage(res);
			res.render(<CountryHomepage topCities={JSON.stringify(citiesLinks)} withSidebar={"false"} />);
		})
		.define("city_homepage", (req, res) => {
			metadataService.setAmpLink(req.path);
			metaKeywordsService.setCityPageKeywords();
			metaTitleAndDescService.setCityHomePage(res);
			res.render(<CityHomepage />);
		})
		.define("states_browser", async (req, res) => {
			const locationService = LocationBrowserService.getInstance();
			const locations = locationService.getStates(req.params["locale"], req.params["product_name"]);
			res.render(<LocationBrowser locations={JSON.stringify(locations)} />);
		})
		.define("cities_browser", async (req, res) => {
			const locationService = LocationBrowserService.getInstance();
			const locations = locationService.getCities(
				req.params["state"],
				req.params["locale"],
				req.params["product_name"]
			);
			res.render(<LocationBrowser locations={JSON.stringify(locations)} />);
		})
		.define("ccpa_form", (req, res) => {
			res.render(<CCPAForm />);
		})
		.define("ccpa_form_success", (req, res) => {
			res.render(<CCPAFormSuccess />);
		})

		.define("categories", async (req, res) => {
			const json = await fetchJSON(config.CATEGORIES_JSON_URL);
			const location = {
				country: req.params["locale"],
				state: req.params["state"],
				city: req.params["city"],
			};

			const categories = CategoryBrowserService.getInstance().getCategories(json, location);
			res.render(<CategoriesBrowser categories={JSON.stringify(categories)} />);
		})
		.define("sub_categories", async (req, res) => {
			const json = await fetchJSON(config.CATEGORIES_JSON_URL);
			const location = {
				country: req.params["locale"],
				state: req.params["state"],
				city: req.params["city"],
			};

			const categoryBrowserService = CategoryBrowserService.getInstance();
			const subCategories = categoryBrowserService.getSubCategories(json, location, req.params["category"]);
			res.render(<CategoriesBrowser categories={JSON.stringify(subCategories)} />);
		})
		.define("categories_products", async (req, res) => {
			const location = {
				country: req.params["locale"],
				state: req.params["state"],
				city: req.params["city"],
			};

			const json = await fetchJSON(config.CATEGORIES_JSON_URL);
			const categoryBrowserService = CategoryBrowserService.getInstance();
			const categoryUri = `${req.params["category"]}/${req.params["sub_category"]}`;
			const subCategory = categoryBrowserService.getSubCategoryNameFromUrl(json, categoryUri);
			const products = categoryBrowserService.getProducts(json, subCategory, location.state, location.city, location.country);
			res.render(<CategoriesBrowser categories={JSON.stringify(products)} />);
		})
		.define("blackfriday", async (req, res) => {
			const { default: route } = await import("./routes/blackfriday");
			route(req, res);
		});

function setCouponTitleAndDescription(coupon: Coupon, res: Response) {
	metaTitleAndDescService.setCouponRouting(res, coupon);
}


function renderHomePage(req: Request, res: Response) {
	const city = locationService.city;
	metaTitleAndDescService.setHomePage(res);
	res.render(<NewLandingPage cityName={city} />);
	metadataService.setAmpLink(req.path);
	metaKeywordsService.setHomePageKeywords();
}

function dispatchFlyerOpen(req: Request, res: Response, next: Middleware) {
	/* Normalize the query parameters */
	function readIds(name: string) {
		return req.params[name] ?
				req.params[name].split(",").map((id) => parseInt(id, 10)) :
				null;
	}

	const flyer_ids = readIds("flyer_ids");
	const flyer_run_ids = readIds("flyer_run_ids");
	const flyer_type_ids = readIds("flyer_type_ids");
	const merchant_ids = readIds("merchant_ids");

	if (!flyer_ids && !flyer_run_ids && !flyer_type_ids && !merchant_ids) {
		/* Route directly to '/flyers' in the case where no parameters are provided */
		res.redirect(linkService.linkTo("listing"));
		return;
	}

	res.render(<ActionLanding
		flyerIds={flyer_ids}
		flyerRunIds={flyer_run_ids}
		flyerTypeIds={flyer_type_ids}
		merchantIds={merchant_ids}/>);
}

function dispatchShoppingListShare(req: Request, res: Response, next: Middleware) {
	res.redirect("/shopping_list");
	return;
}

function dispatchCouponsListing(req: Request, res: Response, next: Middleware) {
	res.redirect(linkService.linkTo("coupons"));
	return;
}

function dispatchFlyerListing(req: Request, res: Response, next: Middleware) {
	const param = req.params["category"];
	const categories = CategoryService.getInstance().getCategoySlugToNameMapping();
	if (param) {
		if (param.toLowerCase() === "favorites") {
			res.redirect(linkService.linkTo("favourites"));
		} else if (param === categories[ConfigService.getInstance().BF_CATEGORY]) {
			return BlackFridayService.getInstance().redirectToHost();
		} else {
			const category = new FlyerCategory(param);
			res.redirect(linkService.linkTo(category));
		}
	} else if (req.params["command"] === "query") {
		res.redirect(linkService.linkTo("search", {"q": req.params["text"]}));
	} else {
		res.redirect(linkService.linkTo("listing"));
	}

	return;
}

function dispatchBrandmediaLanding(req: Request, res: Response, next: Middleware) {
	const param = req.params["url"];
	if (!param) {
		return;
	}

	// Verify that we're on flipp.com
	const a = document.createElement("a");
	a.href = param;

	const hostname = a.hostname;
	const parts = hostname.split(".");

	if (parts.slice(-1)[0] !== "com" || parts.slice(-2)[0] !== "flipp") {
		return;
	}

	// OK we're on flipp.com - go there
	// Example url - https://brandmedia-stg.flipp.com/page/sKY869d23eg.html
	window.location.href = param;

	return;
}

